import WXVoiceInput from "./WXVoiceInput";
export default WXVoiceInput;
